import styled from 'styled-components';
import { stickyYellow } from 'tokens';

export const Base = styled.div`
	position: fixed;
	bottom: 16px;
	z-index: 2;
	display: flex;
	flex-direction: column;
	font-family: inherit;
`;

export const ToggleButton = styled.button`
	align-self: flex-end;
	background: ${stickyYellow.fill};
	border: 1px solid ${stickyYellow.border};
	border-radius: 3px;
	padding: 6px 12px;
	font-size: 12px;
	font-weight: 600;
	color: ${stickyYellow.text};
	box-shadow: 1px 2px 6px ${stickyYellow.shadow};

	&:hover {
		background: ${stickyYellow.fillHover};
	}
`;

export const Panel = styled.div`
	width: 260px;
	max-height: 320px;
	overflow-y: auto;
	background: ${stickyYellow.fill};
	border: 1px solid ${stickyYellow.border};
	border-radius: 3px;
	box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.15);
	margin-top: 6px;
`;

export const Row = styled.div<{ $isDragging: boolean }>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 6px 10px;
	opacity: ${(p) => (p.$isDragging ? 0.4 : 1)};
	border-bottom: 1px solid ${stickyYellow.border}33;

	&:last-child {
		border-bottom: none;
	}
`;

export const DragHandle = styled.span`
	font-size: 14px;
	color: ${stickyYellow.text};
	opacity: 0.4;
	line-height: 1;
`;

export const RowNumber = styled.span`
	font-size: 11px;
	font-weight: 700;
	color: ${stickyYellow.text};
	min-width: 16px;
	text-align: center;
`;

export const RowText = styled.span`
	font-size: 12px;
	color: ${stickyYellow.text};
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
